import ModalFormContract from "./ModalFormContract";

export default ModalFormContract;
